import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Tooltip, Dropdown } from 'antd';
import { useSelector, useDispatch } from "react-redux";
import { me, hasAilabPermission } from '../../utils';
import { routes } from '../../router/config';
import { openScratch } from '../../utils/utils'
import { setScratchConnect } from '../../store/speakerSlice'
import useBluetooth from '../../hooks/useBluetooth.js'
import './style.scss';
import { DownOutlined } from '@ant-design/icons';
const CLOUD_TEST_API = 'https://learn.dev.longan.eliteu.xyz';
const CLOUD_FORMAL_API = 'https://course.aimaker.space'
const CLOUD_API = window.location.host.indexOf('aiwanjia.club') > -1 ?
    CLOUD_FORMAL_API :
    CLOUD_TEST_API;

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showBleConnect, setShowBleConnect] = useState('');
    const [userNickname, setUserNickname] = useState('');
    const [username, setUsername] = useState('');
    const state = useSelector(state => state.speaker);
    const bluetooth = state.bluetooth;
    const scratchConnect = state.scratchConnect
    // const [headPortrait, setHeadPortrait] = useState('');
    let headPortrait = useRef();
    const dispatch = useDispatch();
    const { connect, disconnect } = useBluetooth();
    useEffect(() => {
        // 兼容性检查
        if (!navigator.bluetooth) {
            console.log('错误: 当前浏览器不支持Web Bluetooth API');
        }
        const getUserInfo = async () => {
            try {
                const labToken = Cookies.get("aiwanjiaToken") || Cookies.get("token");
                if (labToken) {
                  sessionStorage.setItem("toKen", `Bearer ${labToken} `);
                  let res = await me();
                  if (res.name) {
                    setUserNickname(res.name);
                  } else {
                    setUserNickname(res.username);
                  }
                  setUsername(res.username);
                  // setHeadPortrait(CLOUD_API + res.avatar_url);
                  headPortrait.current.style = `background-image: url(${
                    CLOUD_API + res.avatar_url
                  });`;
                  sessionStorage.setItem("name", res.username);
                  sessionStorage.setItem("id", res.id);
                  if (sessionStorage.getItem("win") === "true") {
                    openFormScratch();
                  }
                } else {
                  // 如果没有登录，就前往登录页面
                  window.open( CLOUD_API + "/login/?url=" + window.location.href, "_self" );
                }
            } catch (error) {
                console.log('获取用户信息发生错误',error)
            }
        }
        const openFormScratch = () => {
            dispatch(setScratchConnect(true))
                let win = window.open('', "editor");
                let time = setInterval(() => {
                    if (!window.opener || (win && win.closed)) {
                      sessionStorage.setItem("win", "false");
                      clearInterval(time);
                      dispatch(setScratchConnect(false));
                    }
                }, 2000)
        }
        window.onmessage = (event) => {
          console.log("data", event);
          const { data } = event;
          if (data.openFrom && data.openFrom === "Scratch") {
            // 如果是从创作平台打开，那么判断连接的方式就是是否有父页面
            openFormScratch();
          }
        };
        getUserInfo()
    }, [])

    useEffect(() => {
        if (location && routes.find(route => route.path.replaceAll('/', '') === location.pathname.replaceAll('/', ''))?.extention) {
            console.log('扩展功能页')
            setShowBleConnect(true);
        } else {
            setShowBleConnect(false);
        }

        if (username && location.pathname !== '/' && location.pathname !== '/403') {
            const extension_id = location.pathname.replaceAll('/', '');
            // 请求权限接口
            hasAilabPermission({ username, extension_id }).catch((err) => {
                navigate('/403');
            })
        }
    }, [username, location, navigate])

    const home = () => {
        window.location.href = '/';
    }
    return (
        <div className='header'>
            <div className='home' onClick={home}>英荔 AI 实验平台</div>
            <div className='nickname'>
                <span className='headPortrait' ref={headPortrait}></span>
                <span>{userNickname}</span>
            </div>
            <div className='connectState'>
                {
                    scratchConnect ?
                        <div className='connect'>
                            <span className='Connected'></span>
                            已连接到英荔创作平台
                        </div> :
                        <div className='connect' style={{ cursor: 'pointer' }} onClick={() => { openScratch(dispatch) }}>
                            <span className='NotConnected'></span>
                            互联创作平台未连接
                        </div>
                }                
                {
                    showBleConnect &&
                    (bluetooth?.id ?
                        <div className="connect bleConnect">
                            <span className='Connected'></span>


                            <Tooltip placement="bottom" title={bluetooth.name}>
                                主控硬件
                            </Tooltip>
                            <Dropdown menu={{
                                items: [
                                    {
                                        key: '1',
                                        label: <span onClick={disconnect}>断开连接</span>,
                                    },
                                ],
                            }}>
                                <a onClick={e => e.preventDefault()} className='bleConnected'>
                                    已连接 <DownOutlined />
                                </a>
                            </Dropdown>

                        </div> :
                        <Tooltip overlayStyle={{ paddingLeft: '8px' }} placement="bottom" title={'需要先开启电脑的蓝牙功能，然后允许当前浏览器的蓝牙权限，才可以连接到主控硬件'}>
                            <div className="connect bleConnect" onClick={connect}>
                                <span className='NotConnected'></span>
                                主控硬件未连接
                            </div>
                        </Tooltip>)
                }
            </div>
        </div>
    )
}
export default Header;